import React from 'react';
import Header from '../../components/header/header.component';
import Footer from '../../components/footer/footer.component';
import "./offerings.css"
const WhatWeOffer = () => {
    return (
        <div className="header2">
            <Header />
            <div className="container_settings">
                <h1 className='main-head'>Smart Pharmacy Solutions & Global Partnerships</h1>
                <div className='flex-cards'>
                    <div className='row'>
                        <div className='col-md-6 p-0'>
                            <img src={require("../../assets/images/offering-image-two.png")} alt="offering-iamge" />
                        </div>
                        <div className='col-md-6 d-flex justify-content-center align-items-center flex-col'>
                            <h2>
                                Outsourcing Solutions for <span>Medical Institutions!</span>
                            </h2>
                            <p>
                                DawaAsaan offers comprehensive outsourcing services for medical institutions, including clinics, hospitals, and healthcare providers. We handle essential business operations such as medical prescription management, pharmaceutical supply chain services, and other administrative tasks. By partnering with DawaAsaan, healthcare
                                institutions can focus on their core responsibility of providing quality patient care while we manage their operational needs efficiently.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='blocks-card'>
                <div className='card-lifecycle'>
                    <img src={require("../../assets/images/offering-card-one.svg")} alt="card" />
                    <p>Global Healthcare Network</p>
                </div>

                <div className='card-lifecycle'>
                    <img src={require("../../assets/images/offering-card-two.svg")} alt="" />
                    <p>
                        Pharmacy Outsourcing Solutions
                    </p>
                </div>
                <div className='card-lifecycle'>
                    <img src={require("../../assets/images/offering-card-three.svg")} alt="" />
                    <p>
                        Healthcare Partnerships
                    </p>
                </div>
            </div>
            <div className='container_set'>
                <div className='flex-cards'>
                    <div className='row'>
                        <div className='col-md-6 p-0'>
                            <img src={require("../../assets/images/offering-image-one.png")} alt="offering-iamge" />
                        </div>
                        <div className='col-md-6 d-flex justify-content-center align-items-center'>
                            <h2>
                            Smart Pharmacy Solutions &  <span>Global Partnerships </span> 
                            </h2>
                            <p>
                            At DawaAsaan, we are committed to transforming the healthcare industry through smart pharmacy solutions and strategic global partnerships. As Pakistan's first smart pharmacy, we leverage innovative technology to ensure seamless medical adherence and efficient healthcare operations for our partners across borders. Our mission is to become a one-stop solution for all medicinal needs while providing customized services that streamline healthcare processes and improve patient outcomes.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='container_background'>
                <div className='flex-cards'>
                    <div className='row'>
                        <div className='col-md-6 d-flex justify-content-center align-items-center flex-col'>
                            <h2>
                                On-Call IT and  <span>Customer Support</span> for <span> UK Pharmacies!</span>
                            </h2>
                            <p>
                                Recognizing the importance of reliable IT infrastructure and customer service, DawaAsaan provides dedicated on-call IT support and customer service solutions for pharmacies and healthcare providers in the UK. Our experienced team ensures that pharmacies can operate without disruptions, offering prompt technical assistance and addressing customer inquiries to maintain a high level of service quality. This support
                                helps healthcare providers in the UK enhance their operations and offer a better patient experience.
                            </p>
                        </div>
                        <div className='col-md-6 p-0'>
                            <img src={require("../../assets/images/offering-image-four.png")} alt="offering-iamge" />
                        </div>
                    </div>
                </div>
            </div>
            <div className='container_sets'>
                <div className='flex-cards'>
                    <div className='row'>
                        <div className='col-md-6 p-0'>
                            <img src={require("../../assets/images/offering-image-three.png")} alt="offering-iamge" />
                        </div>
                        <div className='col-md-6 d-flex justify-content-center align-items-center flex-col'>
                            <h2>
                                Platform as a Service for <span>Streamlined Operations!</span>
                            </h2>
                            <p>
                                DawaAsaan also offers its cutting-edge platform as a service to companies in the UK, enabling them to streamline and optimize their own operations. Our customizable platform integrates seamlessly into existing workflows, providing tools for inventory management, prescription processing, and patient engagement. By utilizing our platform, businesses can reduce operational inefficiencies and focus on delivering superior healthcare services
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='cards-final'>
                <div className='content-card'>
                    <p className='content-desc'>
                        Through these initiatives, DawaAsaan aims to build long-lasting partnerships that drive innovation and improve healthcare delivery on a global scale. Our commitment to providing smart, scalable solutions ensures that our partners can meet the evolving needs of the healthcare sector while enhancing the overall patient experience.
                    </p>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default WhatWeOffer;
